export const SHARE_COPY = {
  generalAccess: "General access",
  restricted: "Restricted",
  restrictedHint: "Only people you invite",
  workspace: "Anyone in the workspace with the link",
  workspaceHint: "Must sign in to the workspace",
  anyone: "Anyone with the link can view",
  anyoneHint: "No sign-in needed",
  warningLead: "Anyone with the link sees this story with your data access.",
  warningRest: "Share it only with people who should see this data.",
  lifetime: "Link lifetime",
  link: "Link",
  copyLink: "Copy link",
  linkUrl: "Link URL",
  previewHeading: "Live preview",
  previewTitle: "Embed preview",
  previewEmpty: "Preparing the preview…",
  previewUnavailable: "The preview is not available for this story.",
  copied: "Copied!",
  changeInEmbed: "Change in Embed settings",
  loadError: "Unable to load share links.",
  saveError: "Unable to save the share link.",
  resetError: "Unable to reset the link.",
  loading: "Loading…",
} as const;
